export const getWebcomponentRootFromElement = (hostElement: HTMLElement | undefined): Element | undefined => {
  if (!hostElement) {
    return;
  }

  const rootNode = hostElement.getRootNode({ composed: false });

  return (rootNode as ShadowRoot)?.host;
};
